import { render, staticRenderFns } from "./ship-fare.vue?vue&type=template&id=3da8967c"
import script from "./ship-fare.vue?vue&type=script&lang=js"
export * from "./ship-fare.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports